export class CommandManager {
    _dostack = [];
    _redoStack = [];
    clear() {
        this._dostack.length = 0;
        this._redoStack.length = 0;
    }
    async action(command, viewer) {
        try {
            this._redoStack.length = 0;
            this._dostack.push(command);
            await command.execute(viewer);
            viewer.requestRender();
        }
        catch (error) {
            console.log(error);
            this._dostack.pop();
        }
    }
    async execute() { }
    async undo(viewer) {
        const command = this._dostack.pop();
        try {
            if (command) {
                await command.undo(viewer);
                this._redoStack.push(command);
            }
        }
        catch (error) {
            this._dostack.push(command);
            console.log(error);
        }
    }
    async redo(viewer) {
        try {
            const command = this._redoStack.pop();
            if (command) {
                this._dostack.push(command);
                await command.execute(viewer);
            }
        }
        catch (error) {
            console.log(error);
        }
    }
}
//# sourceMappingURL=commands.js.map